import { Button, Stack, Tab, Tabs, Typography, Link } from "@mui/material";
import {
  CustomTabPanel,
  CustomTable,
  CustomeDialog,
  DeleteModal,
  Loader,
  PageListLayout,
} from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useStores } from "../hooks";
import { createColumnHelper } from "@tanstack/react-table";
import { AddMacDialog } from "../components";
import StoreMappedRecipe from "../components/StoreMappedRecipe";

export const StoreDetail = () => {
  let { id } = useParams();

  const {
    state,
    setState,
    storeDetails,
    handleModal,
    removeMac,
    onChange,
    handleAddMacId,
    handleDeleteMacTag,
    onSaveMac,
    isMacidView,
    isDeviceView,
    isStoreAssignMacid,
    isMacidDelete,
    onSearchHandler,
    onClearFilter,
    handleOpenDialog,
    assignRecipeToStore,
    handleAssignRecipeToStore,
    selectChipCategory,
    storeMappedRecipe,
    handleDeleteRecipeFromStore,
    recipeChipCategoryValuesHandler,
    storeMappedAllRecipe,
  } = useStores({
    storeId: id,
  });

  const navigate = useNavigate();
  const { search } = useLocation();
  const isPageLoading = storeDetails?.isLoading;

  const handleChange = (event, newValue) => {
    navigate(`/store/details/${id}${newValue}`);
    setState((draft) => {
      draft.chipCategoryId =
        selectChipCategory.chipCategory.chipCategoryOptions[0]?.id;
    });
  };

  const breadcrumbs = [
    <Link
      underline="none"
      key="1"
      color="#1760D2"
      onClick={(e) => navigate("/store")}
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      Stores
    </Link>,
    <Typography
      key="2"
      color="inherit"
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      {isPageLoading ? "..." : storeDetails?.data[0]?.name}
    </Typography>,
  ];
  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: () => "Device Name",
    }),
  ];

  const columns2 = [
    columnHelper.accessor("mac_id", {
      header: () => "MAC ID",
    }),
    columnHelper.accessor("actions", {
      header: () => "",
      align: "right",
      cell: ({ row }) => {
        return (
          isMacidDelete && (
            <Stack
              justifyContent="end"
              sx={{ cursor: "pointer", width: "fit-content", ml: "auto" }}
              onClick={() =>
                handleModal("delete-mac", true, row.original.mac_id)
              }
            >
              <img alt="delete" src="/icons/ic_trash.svg" />
            </Stack>
          )
        );
      },
    }),
  ];

  return (
    <>
      <PageListLayout
        breadcrumbs={breadcrumbs}
        headerText={
          isPageLoading ? "Loading..." : storeDetails?.data?.[0]?.name
        }
        tabs={
          <Tabs value={search} onChange={handleChange}>
            {isMacidView && <Tab label="MAC IDs" value={""} />}
            {isDeviceView && <Tab label="Devices" value={"?devices"} />}
            {<Tab label="Recipes" value={"?recipes"} />}
          </Tabs>
        }
        sx={{
          p: search === "?recipes" ? "8px 8px 0px 8px" : "0px 16px 0px 16px",
          backgroundColor: search !== "?recipes" && "#ffffff",
          minHeight: "calc(100vh - 145px)",
        }}
      >
        {storeDetails?.isLoading ? (
          <Loader />
        ) : (
          <>
            <CustomTabPanel value={search} index={""} border={false}>
              <CustomTable
                defaultData={storeDetails?.data[0]?.mac_id ?? []}
                columns={columns2}
                headerText="MAC IDs"
                showSearchBar={false}
                isPagination={false}
                isLoading={storeDetails?.isLoading}
                rightContent={
                  isStoreAssignMacid && (
                    <Button
                      type="button"
                      size="small"
                      variant="outlined"
                      color="gray2"
                      startIcon={<AddIcon />}
                      onClick={() => handleModal("add-mac", true)}
                    >
                      Assign MAC ID
                    </Button>
                  )
                }
                tableHeaderStyles={{ fontSize: "18px", fontWeight: 500, px: 0 }}
                enableTableContainerPaddingBottom
              />
            </CustomTabPanel>
            <CustomTabPanel value={search} index={"?devices"} border={false}>
              <CustomTable
                defaultData={storeDetails?.data[0]?.devices ?? []}
                columns={columns}
                headerText="Devices"
                isPagination={false}
                isLoading={storeDetails?.isLoading}
                rightContent={<></>}
                tableHeaderStyles={{ fontSize: "18px", fontWeight: 500, px: 0 }}
                enableTableContainerPaddingBottom
              />
            </CustomTabPanel>
            <CustomTabPanel value={search} index={"?recipes"} border={false}>
              <StoreMappedRecipe
                state={state}
                onSearchHandler={onSearchHandler}
                setState={setState}
                onClearFilter={onClearFilter}
                handleOpenDialog={handleOpenDialog}
                assignRecipeToStore={assignRecipeToStore}
                handleAssignRecipeToStore={handleAssignRecipeToStore}
                selectChipCategory={selectChipCategory}
                storeMappedRecipe={storeMappedRecipe}
                handleDeleteRecipeFromStore={handleDeleteRecipeFromStore}
                recipeChipCategoryValuesHandler={
                  recipeChipCategoryValuesHandler
                }
                storeMappedAllRecipe={storeMappedAllRecipe}
              />
            </CustomTabPanel>
          </>
        )}
        <CustomeDialog
          title="Assign MAC ID"
          PaperProps={{
            sx: {
              minWidth: { sm: "482px", xs: "90%" },
              maxWidth: { sm: "482px", xs: "90%" },
            },
          }}
          sx={{
            maxHeight: "90vh",
          }}
          open={state?.addMacOpen}
          CloseIcons={false}
          divider={false}
          content={
            <AddMacDialog
              onChange={onChange}
              onSubmit={onSaveMac}
              state={state}
              handleClose={() => handleModal("add-mac", false)}
              handleAddMacId={handleAddMacId}
              handleDeleteMacTag={handleDeleteMacTag}
            />
          }
        />
        <DeleteModal
          open={state?.deleteMacOpen}
          handleClose={() => handleModal("delete-mac", false, null)}
          onConfirm={() => removeMac()}
        />
      </PageListLayout>
    </>
  );
};
